import React, { useEffect, useState } from "react";
import {
  Loading,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
  Form,
  Row,
  Column,
  TextInput,
  Button,
  Tag,
} from "carbon-components-react";
import { DataViewAlt24, Search32 } from "@carbon/icons-react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { toast } from "react-toastify";

const tableHeaders = [
  { header: "Empresa", key: "companyName" },
  { header: "Estado", key: "status" },
  { header: "Pontuação", key: "score" },
  { header: "Data de Pontuação", key: "evaluationDate" },
  { header: " ", key: "actions" },
];

const getCellContent = (cell, rowId) => {
  if (cell.info.header === "actions") {
    return (
      <Link to={`../prototype/${rowId}`} title="Ver Protótipo">
        <DataViewAlt24 />
      </Link>
    );
  }
  if (cell.info.header === "status") {
    return cell.value === "SUBMITTED" ? (
      <Tag type="green">Submetido</Tag>
    ) : (
      <Tag type="gray">Rascunho</Tag>
    );
  }
  if (cell.info.header === "score") {
    return cell.value?.isScored ? cell.value.totalScore : "Não Pontuado";
  }
  return cell.value;
};

const JuryPrototypesPage = () => {
  const [prototypes, setPrototypes] = useState([]);
  const [filteredPrototypes, setFilteredPrototypes] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);
  const [isLoading, setIsLoading] = useState(true);

  const { register, handleSubmit } = useForm();

  const fetchPrototypes = async () => {
    try {
      const response = await http.get("/prototypes");
      const data = response.data.map((p) => ({
        id: p.uuid,
        companyName: p.companyName,
        status: p.prototypeStatus,
        score: {
          isScored: p.isScored || false,
          totalScore:
            p.totalScore != null
              ? typeof p.totalScore === "number"
                ? p.totalScore.toFixed(2)
                : p.totalScore
              : "-",
        },
        evaluationDate: p.evaluationDate || "-",
      }));
      setPrototypes(data);
      setFilteredPrototypes(data);
      setCount(data.length);
    } catch (error) {
      toast.error("Erro ao carregar protótipos");
    } finally {
      setIsLoading(false);
    }
  };

  const onSearch = (data) => {
    if (!data.companyName) {
      setFilteredPrototypes(prototypes);
      setCount(prototypes.length);
      return;
    }
    const filtered = prototypes.filter((p) =>
      p.companyName.toLowerCase().includes(data.companyName.toLowerCase())
    );
    setFilteredPrototypes(filtered);
    setCount(filtered.length);
  };

  const onPageChange = ({ pageSize }) => {
    setSize(pageSize);
  };

  useEffect(() => {
    fetchPrototypes();
  }, []);

  return (
    <Card title="Protótipos — Pontuação">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />
      <DataTable
        rows={filteredPrototypes}
        headers={tableHeaders}
        isSortable
        useZebraStyles
      >
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="prototypes toolbar">
              <TableToolbarContent>
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={8} lg={8}>
                      <TextInput
                        id="companyName"
                        labelText=""
                        placeholder="Nome da Empresa"
                        {...register("companyName")}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      {...getHeaderProps({ header })}
                      key={header.key}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default JuryPrototypesPage;
